"use client";

import Link from "next/link";
import type { ComponentProps, ReactNode } from "react";
import { track } from "@/lib/analytics";

type Props = Omit<ComponentProps<typeof Link>, "href" | "onClick"> & {
  href: string;
  event: string;
  tracking: Record<string, unknown>;
  children: ReactNode;
};

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const;

function getUtmParams(): Record<(typeof UTM_KEYS)[number], string | undefined> {
  const searchParams = new URLSearchParams(window.location.search);
  return Object.fromEntries(
    UTM_KEYS.map((key) => [key, searchParams.get(key) || undefined]),
  ) as Record<(typeof UTM_KEYS)[number], string | undefined>;
}

export default function LandingCtaLink({
  href,
  event,
  tracking,
  children,
  ...props
}: Props) {
  return (
    <Link
      href={href}
      onClick={() => {
        track(event, {
          href,
          ...tracking,
          ...getUtmParams(),
        });
      }}
      {...props}
    >
      {children}
    </Link>
  );
}
